var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xF0\\x9F\\x93\\x8D my_location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/maps/my_location_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.96 7.333A5.996 5.996 0 0 0 8.667 2.04V.667H7.334V2.04A5.996 5.996 0 0 0 2.04 7.333H.667v1.333H2.04a5.996 5.996 0 0 0 5.294 5.294v1.373h1.333V13.96a5.996 5.996 0 0 0 5.293-5.294h1.374V7.333H13.96Zm-5.96-2a2.666 2.666 0 1 0 0 5.333 2.666 2.666 0 1 0 0-5.333ZM3.334 8A4.663 4.663 0 0 0 8 12.666 4.663 4.663 0 0 0 12.667 8 4.663 4.663 0 0 0 8 3.333 4.663 4.663 0 0 0 3.334 8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my_location.ab47a85d647a25c796392871ab9e8045.svg";
export { ForwardRef as ReactComponent };